const Codings = ({}) => {

    return (
        <div>
            코딩 일정
        </div>
    )

}

export default Codings;